
import VLazyImage from 'v-lazy-image'
import config from '@/config'

export default {
  name: 'SectionWork',

  components: {
    VLazyImage,
  },

  data() {
    return {
      projects: config.projects,
    }
  },
}
